import ReactDOM from 'react-dom';
import styles from './BottomSheet.module.css'
import { Dispatch, forwardRef, SetStateAction, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useBackDismiss } from 'hooks/useBackDismiss';

/** 클래스 이름을 해시된 이름으로 바꿉니다. 모르는 이름은 그대로 둡니다.
 *  이름을 바꾸지 않고 스코프만 씌우려고 둔 얇은 헬퍼입니다. */
const cls = (names?: string): string =>
    (names || '').split(' ').filter(Boolean)
        .map((n) => (styles as Record<string, string>)[n] || n).join(' ');

interface BottomSheetProps {
    children: React.ReactNode
    isOpen: boolean
    setIsOpen: Dispatch<SetStateAction<boolean>>
}

export const BottomSheet = ({children, isOpen, setIsOpen} : BottomSheetProps) => {
    const portalRoot = document.getElementById("portal");
    const [isVisible, setIsVisible] = useState(false);
    const scrimRef = useRef<HTMLDivElement>(null);
    const bottomSheetRef = useRef<HTMLDivElement>(null);

    const openTimer = useRef<NodeJS.Timer | undefined>(undefined);
    const closeTimer = useRef<NodeJS.Timer | undefined>(undefined);


    const openBottomSheet = () => {
        if(closeTimer.current) clearTimeout(closeTimer.current);
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                // CSS Modules 라 'open' 은 해시된 이름이어야 합니다.
                // 문자열 그대로 붙이면 규칙이 안 걸려 시트가 화면 밖에 머뭅니다.
                bottomSheetRef.current?.classList.add(cls('open'));
                scrimRef.current?.classList.add(cls('open'));
            })
        })
        
    }

    const closeBottomSheet = () => {
        if(openTimer.current) clearTimeout(openTimer.current);
        bottomSheetRef.current?.classList.remove(cls('open'));
        scrimRef.current?.classList.remove(cls('open'));
        closeTimer.current = setTimeout(() => {
            setIsOpen(false);
            setIsVisible(false);       
        }, 300)
    }

    useEffect(() => {
        if(isOpen) {
            setIsVisible(true);
        } else {
            closeBottomSheet();
        }
    },[isOpen])

    useEffect(() => {
        if(isVisible) {
            openBottomSheet();
        }
    },[isVisible])

    useBackDismiss(isOpen, () => setIsOpen(false));

    if(!portalRoot || !isVisible) return null;

    return ReactDOM.createPortal(
        <div
            className={cls("bottom-sheet-container")}
        >
            <div className={cls("bottom-sheet-scrim")}
                onClick={() => {
                    closeBottomSheet();
                }}
                ref={scrimRef}
            />
            <div
                className={cls("bottom-sheet")}
                ref={bottomSheetRef}
            >
                {children}
            </div>
        </div>
    , portalRoot)
};